import { useMutation } from "@tanstack/react-query";
import { apiClient } from "./api-client";

export function useGetAllCourses() {
  return useMutation({
    mutationFn: ({ page, limit, isActive, search }) => {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit)
      });
      if (isActive !== undefined && isActive !== null && isActive !== "") {
        params.append("isActive", String(isActive));
      }
      if (search !== undefined && search !== null && String(search).trim() !== "") {
        params.append("search", String(search).trim());
      }
      return apiClient({
        url: `admin/courses/all?${params.toString()}`,
        method: "GET"
      });
    }
  });
}

export function useCourseCreate() {
  return useMutation({
    mutationFn: (payload) =>
      apiClient({ url: "admin/courses/create", method: "POST", data: payload })
  });
}

export function useCourseUpdate() {
  return useMutation({
    mutationFn: ({ slug, ...data }) =>
      apiClient({ url: `admin/courses/update/${slug}`, method: "PATCH", data })
  });
}

export function useToggleCourseStatus() {
  return useMutation({
    mutationFn: ({ slug, status }) =>
      apiClient({
        url: `admin/courses/activate-deactivate/${slug}`,
        method: "PATCH",
        data: { status }
      })
  });
}
